import classNames from 'classnames';

function spreadClassNames(base = '', custom = '') {
  return (...names: (string | string[] | { [key: string]: boolean })[]) => {
    const customNames = custom.split(' ').filter(Boolean);

    const result: string[] = [];

    if (!names.length) {
      names.push('');
    }

    names.forEach((name) => {
      if (typeof name === 'string') {
        const suffixes = name.split(' ');

        for (const s of suffixes) {
          result.push(base + s);

          for (const c of customNames) {
            result.push(c + s);
          }
        }
      } else if (Array.isArray(name)) {
        name.forEach((n) => {
          result.push(base + n);

          for (const c of customNames) {
            result.push(c + n);
          }
        });
      } else if (typeof name === 'object') {
        Object.keys(name).forEach((n) => {
          if (!name[n]) {
            return;
          }

          result.push(base + n);

          for (const c of customNames) {
            result.push(c + n);
          }
        });
      }
    });

    return classNames(result);
  };
}

export { spreadClassNames };
